import { render, staticRenderFns } from "./BRadioCard.vue?vue&type=template&id=3968665e&scoped=true"
import script from "./BRadioCard.vue?vue&type=script&lang=ts"
export * from "./BRadioCard.vue?vue&type=script&lang=ts"
import style0 from "./BRadioCard.vue?vue&type=style&index=0&id=3968665e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968665e",
  null
  
)

export default component.exports